import React, { useState } from 'react';
import { Box } from '@mui/material';
import GlobalWebhook from '../components/GlobalWebhook';
import WebhookTable from '../components/WebhookTable';
import WebhookActions from '../components/WebhookActions';
import { useGetWebhookHandler } from '../dataHandlers/getWebhooksHandler';
import WebhookPageHeader from '../components/WebhookPageHeader';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const WebhookListPage = () => {
  useDocumentTitle('Webhooks');
  const [search, setSearch] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedWebhook, setSelectedWebhook] = useState(null);

  const { webhooks: globalWebhook, isLoading: isGlobalWebhookLoading } = useGetWebhookHandler({ is_global: true });
  const { webhooks, hasMore, isLoadingMore, loadMore, isLoading } = useGetWebhookHandler(
    search ? { name: search } : {},
  );

  const openMenu = (e, webhook) => {
    setAnchorEl(e.currentTarget);
    setSelectedWebhook(webhook);
  };

  const closeMenu = () => setAnchorEl(null);

  return (
    <Box sx={{ p: 1, color: '#fff', ml: 20, mr: 20 }}>
      <WebhookPageHeader />

      <GlobalWebhook webhook={globalWebhook} />

      <WebhookTable
        webhooks={webhooks}
        onSearch={setSearch}
        onOpenMenu={openMenu}
        loadMore={loadMore}
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
        isLoading={isLoading}
      />

      <WebhookActions selectedWebhook={selectedWebhook} anchorEl={anchorEl} onClose={closeMenu} />
    </Box>
  );
};

export default WebhookListPage;
